import mHelper from '../../config/Helper';
var isLogin = JSON.parse(mHelper.GET_COOKIES('login_portal'));

class Dashboards {

    READ_DASHBOARD  = (periode,callback) => {
        fetch(mHelper.URL_API() + "/dashboard", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                periode : periode
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }


    GET_NOTIFICATION = (params, callback) => {
        var filter = JSON.stringify(params);
        fetch(mHelper.URL_API() + "/profile/notification?filter="+filter , {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            }
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    READ_NOTIFICATION  = (id,callback) => {
        fetch(mHelper.URL_API() + "/profile/on_read_notif", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                notif_id : id
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    CHANGE_PASSWORD = (old_pass,new_pass,confirm_pass,callback) => {
        fetch(mHelper.URL_API() + "/profile/reset-password", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                old_pass: old_pass,
                new_pass: new_pass,
                confirm_pass: confirm_pass 
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    LOGOUT_TOKEN = (token,callback) => {
        fetch(mHelper.URL_API() + "/profile/logout", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body:JSON.stringify({
                token: token
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    GET_FILE_DOC = (params, callback) => {
        fetch(mHelper.URL_API() + "files/doc_information", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify(params)
        })
        .then((response) =>  response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }  
}

const mDashboardControllers = new Dashboards();
export default mDashboardControllers;
